import React from 'react'
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'

import { DataTable, } from '../revel-strap'

import { numberFunc, dateFunc, } from '../../utils'

import { ChequePayModel, } from '../../models'

const cheque_pay_model = new ChequePayModel()

class ChequePaySearchModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      index_buffers: [],
      cheque_pays: [],
    }
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this._fetchData()
    }
  }

  _fetchData = () => this.setState({ loading: true, }, async () => {
    const { cheque_pay_code } = this.props

    const cheque_pays = await cheque_pay_model.generateChequePayBy({ cheque_pay_code, })

    cheque_pays.data.forEach(item => {
      item.cheque_pay_balance = numberFunc.decimalFix(item.cheque_pay_balance, 2)
    })

    this.setState({
      loading: false,
      index_buffers: [],
      cheque_pays,
    })
  })

  _handleSave = () => this.props.onSave(this.state.index_buffers)
  _handleClose = () => this.props.onClose()

  render() {
    return (
      <Modal size="xl" centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}>ค้นหาเช็คจ่าย</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <FormGroup>
                <div className="alert-box alert-info" style={{ height: 36, padding: 8, }}>ทั้งหมด : {this.state.cheque_pays.length} รายการ</div>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup className="text-right">
                <Button type="button" color="primary" onClick={() => this._fetchData()}>
                  <i className="fa fa-refresh" aria-hidden="true" />
                </Button>
              </FormGroup>
            </Col>
          </Row>
          <DataTable
            loading={this.state.loading}
            dataSource={this.state.cheque_pays.data}
            setProps={{
              rowSelection: {
                type: "checkbox",
                preserveSelectedRowKeys: true,
                onChange: (selectedRowKeys, selectedRows) => this.setState({ index_buffers: selectedRows, }),
              },
            }}
            rowKey='cheque_pay_code'
            columns={[
              {
                title: "ผู้รับเงิน",
                dataIndex: "supplier_name",
                filterAble: true,
                ellipsis: true,
              },
              {
                title: "วันที่ภายในเช็ค",
                dataIndex: "cheque_pay_write_date",
                render: (cell) => dateFunc.toFormat(cell, 'DD/MM/YYYY'),
                sorter: (a, b) => new Date(a.cheque_pay_write_date) - new Date(b.cheque_pay_write_date),
                ellipsis: true,
                align: 'center',
                width: 120,
              },
              {
                title: "เลขที่เช็ค",
                dataIndex: "cheque_pay_number",
                filterAble: true,
                ellipsis: true,
              },
              {
                title: "ธนาคาร",
                dataIndex: "bank_name",
                filterAble: true,
                ellipsis: true,
              },
              {
                title: "จำนวนเงิน",
                dataIndex: "cheque_pay_price",
                render: (cell) => numberFunc.decimalFix(cell, 2),
                sorter: (a, b) => a.cheque_pay_price - b.cheque_pay_price,
                align: 'right',
              },
            ]}
          />
        </ModalBody>
        <ModalFooter>
          <div className="flex-grow-1 alert-success" style={{ height: 36, padding: 8, }}>เลือก : {this.state.index_buffers.length} รายการ</div>
          <Button type="button" color="primary" onClick={this._handleSave}>เพิ่มรายการ</Button>
          <Button type="button" onClick={this._handleClose}>ยกเลิก</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ChequePaySearchModal